import { AiIcon, HttpIcon, MailIcon, MessageIcon, SendIcon } from '../../shared/ui/icons';
import type { TCredentialApp } from '../../entities/credential';

const ICON = {
  anthropic: AiIcon,
  openai: AiIcon,
  openai_compatible: AiIcon,
  slack: MessageIcon,
  telegram: SendIcon,
  smtp: MailIcon,
  http: HttpIcon,
} as const;

export const AppIcon = ({ app, size = 13 }: { app: TCredentialApp | null; size?: number }) => {
  const Glyph = app ? ICON[app] : HttpIcon;
  return (
    <span
      aria-hidden
      className="flex size-avatar shrink-0 items-center justify-center rounded-item bg-ghost text-muted"
    >
      <Glyph size={size} />
    </span>
  );
};
